// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34N1i","controls":"styles_controls__3Ai2l","charLimit":"styles_charLimit__2OJfN","input":"styles_input__2NC9B","send":"styles_send__eBmuO"};